import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLv = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#9D2235", d: "M0 0h6v3H0" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 1.2h6v.6H0" }));
const ForwardRef = forwardRef(SvgLv);
const Memo = memo(ForwardRef);
export default Memo;
